var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-dialog',{attrs:{"width":750,"identifier":"module-changelog-dialog"},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var params = ref.params;
return [(params.entry)?_c('i18n',{staticClass:"heading",attrs:{"path":"changelog-dialog.module.title","tag":"h2"}},[_vm._v("\n      "+_vm._s(params.entry.readableName)+"\n    ")]):_vm._e()]}},{key:"default",fn:function(ref){
var params = ref.params;
return [(params.entry)?_c('div',_vm._l((params.entry.docs.changelog),function(changelog,index){return _c('nl2br',{key:index,attrs:{"text":changelog,"tag":"p"}})}),1):_vm._e()]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71cc5c56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/ModuleChangelogDialog.vue
// module id = null
// module chunks = 